var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6668 19.9997C36.6668 29.2044 29.2049 36.6663 20.0002 36.6663C10.7954 36.6663 3.3335 29.2044 3.3335 19.9997C3.3335 10.7949 10.7954 3.33301 20.0002 3.33301C29.2049 3.33301 36.6668 10.7949 36.6668 19.9997ZM21.4934 15.23L10.2699 19.8543C8.29494 20.625 9.45101 21.3475 9.45101 21.3475C9.45101 21.3475 11.1369 21.9256 12.582 22.3591C14.0271 22.7926 14.7978 22.3109 14.7978 22.3109L21.5897 17.7348C23.9982 16.0971 23.4202 17.4458 22.8421 18.0238C21.5897 19.2762 19.5184 21.2512 17.7843 22.8408C17.0136 23.5152 17.399 24.0932 17.7362 24.3822C18.7164 25.2116 21.0244 26.7197 22.0737 27.4053C22.3651 27.5957 22.5594 27.7227 22.6013 27.7541C22.8421 27.9468 24.1909 28.8138 25.0098 28.6211C25.8287 28.4285 25.925 27.3206 25.925 27.3206L27.1292 19.7579C27.2363 19.0489 27.3433 18.3548 27.4431 17.7075C27.7026 16.024 27.9133 14.6574 27.9481 14.1703C28.0926 12.5325 26.3585 13.2069 26.3585 13.2069C26.3585 13.2069 22.6013 14.7483 21.4934 15.23Z",
    fill: "#0D216D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegram);
export default __webpack_public_path__ + "static/media/ic-telegram.34926762d1bb053c95a9e8158163a39b.svg";
export { ForwardRef as ReactComponent };